import useDropdown from "../../../hooks/dropdown-item.hook";

function Toggle({ children }) {
	const { isOpen, handleToggle } = useDropdown();

	return (
		// biome-ignore lint/a11y/useSemanticElements: the toggle wraps caller-provided content that may contain interactive controls.
		<div
			onClick={handleToggle}
			onKeyDown={(event) => {
				if (event.key === "Enter" || event.key === " ") {
					event.preventDefault();
					handleToggle();
				}
			}}
			role="button"
			tabIndex={0}
		>
			{typeof children === "function" ? children({ isOpen }) : children}
		</div>
	);
}

export default Toggle;
